import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { enModoPreview } from '../dev/preview-mode';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn() || enModoPreview()) {
    return true;
  }

  // Persist requested route to redirect after successful login
  sessionStorage.setItem('postLoginRedirectUrl', state.url || '/dashboard');

  // Route unauthenticated users to login preserving attempted url
  return router.createUrlTree(['/login'], {
    queryParams: { redirectTo: state.url || '/dashboard' }
  });
};
